import { Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import { BsQuestionCircle } from "react-icons/bs";
import styles from "./live-queue-badge.module.scss";

type Props = {
  validityDays: number;
};

const LiveQueueBadge = ({ validityDays }: Props) => (
  <div className={styles.wrapper}>
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip>
          This is transit ferry, booking is valid for {validityDays} days.
        </Tooltip>
      }
    >
      <span>
        <Badge bg="info">Live queue</Badge> <BsQuestionCircle />
      </span>
    </OverlayTrigger>
  </div>
);

export default LiveQueueBadge;
